import React from 'react'
import Banner from '../Shared/Banner/Banner';
import Product from './Product/Product';
import './Products'

export default function Products() {
  return (
    <div>
        <Banner title="Our Products" />
        <Product />
    </div>
  )
}
